import { render, staticRenderFns } from "./OnlineCardComponent.vue?vue&type=template&id=8d35a70a&scoped=true&"
import script from "./OnlineCardComponent.vue?vue&type=script&lang=js&"
export * from "./OnlineCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d35a70a",
  null
  
)

export default component.exports